module.exports = __webpack_public_path__ + "img/roulette.470b31dc.png";